import React, { useEffect, useState } from "react";
import AppLogo from "../AppLogo/AppLogo";
import BrandColors from "@brand-colors";
import { Dropdown, Avatar, Grid, Space, theme } from "antd";
import { DownOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import { useSelector } from "react-redux";
import whitelabelConfig from "@whitelabel-config";
import { useLocation } from "react-router-dom";
import LanguageDropdown from "pages/Survey/LanguageDropDown";
const items: MenuProps["items"] = [
  {
    label: <a href="/memberlogin">Logout</a>,
    key: "0",
  },
  {
    type: "divider",
  },
];
const { useToken } = theme;
const { useBreakpoint } = Grid;
const titleColorBlack = whitelabelConfig.uiSettings.titleColorBlack;
const HeaderDefault = () => {
  const header = whitelabelConfig.uiSettings.isHeader;
  const portalSessionMeta = useSelector(
    (state: any) => state.portal.micrositeSession
  );

  let isMicrosite = false;
  console.log("portalSessionMeta", portalSessionMeta);
  if (portalSessionMeta.landingUrlSnapshot.includes("/s/")) {
    isMicrosite = true;
  }
  const location = useLocation();
  const { token } = useToken();
  const [userName, setUserName] = useState();
  const [userNameShort, setUserNameShort] = useState();
  const screens = useBreakpoint();
  const portalAuthSessionMeta = useSelector(
    (state: any) => state.portal.authSession
  );
  const styles = {
    container: {
      alignItems: "center",
      height: "100%",
      display: "flex",
      justifyContent: "space-between",
      margin: "0 auto",
      maxWidth: token.screenXL,
      padding: screens.md
        ? `0px ${token.paddingLG}px`
        : `0px ${token.padding}px`,
    },
    header: {
      backgroundColor: BrandColors.HEADER_BG,
      borderBottom: `${token.lineWidth}px ${token.lineType} ${token.colorSplit}`,
      position: "sticky",
      height: screens.md ? "80px" : "70px",
      top: "0",
      zIndex: "999",
    },
    logo: {
      display: "block",
      height: screens.md ? (whitelabelConfig.uiSettings.logoHeightFull === true ? "80px" : "50px") : (whitelabelConfig.uiSettings.logoHeightFull === true ? "70px" : "40px"),
      left: screens.xs ? (!isMicrosite) ? "44%" : "50%" : "50%",
      position: screens.md ? "static" : "absolute",
      top: "50%",
      transform: screens.md ? " " : "translate(-50%, -50%)",
    },
    menu: {
      backgroundColor: "transparent",
      borderBottom: "none",
      lineHeight: screens.sm ? "4rem" : "3.5rem",
      marginLeft: screens.md ? "0px" : `-${token.size}px`,
      width: screens.md ? "inherit" : token.sizeXXL,
    },
    menuContainer: {
      alignItems: "center",
      display: "flex",
      gap: token.size,
      width: "100%",
      justifyContent: "center",
    },
    logoImg: {
      height: "50px",
    },
    LanguageDropdown: {
      position: "absolute",
      top: "0px",
      left: "15px",
      // textTransform: "capitalize",
    },
  };
  const getUsernameShort = (longUserName: string) => {
    let avatarShort = longUserName
      ? longUserName.match(/\b(\w)/g).join("")
      : "";
    return (longUserName ? longUserName : "").split("")?.length > 1
      ? avatarShort.toUpperCase()
      : (longUserName ? longUserName : "").substring(0, 2).toUpperCase();
  };
  useEffect(() => {
    console.log("portalAuthSessionMeta ", portalAuthSessionMeta);
    if (portalAuthSessionMeta.user_name?.length > 0) {
      setUserName(portalAuthSessionMeta.user_name);
      setUserNameShort(getUsernameShort(portalAuthSessionMeta.user_name));
    }
  }, [portalAuthSessionMeta.user_name]);

  return (
    <nav style={styles.header as any}>
      <div style={styles.container} data-testid="header-default">
        <div style={styles.menuContainer}>
          <a style={styles.logo as any} href="#">
            <AppLogo data-testid="app-logo" />
          </a>
        </div>
        {isMicrosite && header === "HEADER-DEFAULT" && userName && (
          <div style={{ position: "absolute", right: "10px" }}>
            <Dropdown
              menu={{ items }}
              trigger={
                location.pathname.split("/")[1] === "member" ? ["click"] : []
              }
            >
              <a
                data-testid="header-dropdown-btn"
                onClick={(e) => e.preventDefault()}
                style={{ color: titleColorBlack ? titleColorBlack : "#ffffff" }}
              >
                <Space>
                  <Avatar size={40}>{userNameShort}</Avatar>
                  {screens.md && <span>{userName}</span>}
                  {location.pathname.split("/")[1] === "member" && (
                    <DownOutlined />
                  )}
                </Space>
              </a>
            </Dropdown>
          </div>
        )}

        {!isMicrosite && userName && (
          <div style={{ position: "absolute", right: "10px" }}> 
          {(
            location.pathname !== "/member/memberportalagreement" &&
            location.pathname !== "/member/memberportalthankyou" &&
            location.pathname !== "/surveymemberportal"
          ) && (
            <div style={styles.LanguageDropdown}><LanguageDropdown /></div>
          )}            
            <Dropdown
              menu={{ items }}
              trigger={
                location.pathname.split("/")[1] === "member" ? ["click"] : []
              }
            >
              <a
                data-testid="header-dropdown-btn"
                onClick={(e) => e.preventDefault()}
                style={{ color: titleColorBlack ? titleColorBlack : "#ffffff" }}
              >
                <Space>
                  <Avatar size={40}>{userNameShort}</Avatar>
                  {screens.md && <span>{userName}</span>}
                  {location.pathname.split("/")[1] === "member" && (
                    <DownOutlined />
                  )}
                </Space>
              </a>
            </Dropdown>
          </div>
        )}
      </div>
    </nav>
  );
};
export default HeaderDefault;
